import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import {
  tablet_portrait_breakpoint,
  desktop_breakpoint_extended,
  md_laptop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

const OverviewStyles = styled.div`
  padding: 0;

  .overview-container {
    background-color: ${Colors.secondary.grey6.standard};
    padding: 60px 7% ${(props) => (props.quote ? '100px' : '60px')};

    h1 {
      color: ${Colors.primary.black.standard};
      font-size: 32px;
      line-height: 1.19;
      margin: 16px 0;
    }

    p {
      color: ${Colors.accent.grey1.standard};
      font-weight: 400;
      font-size: 16px;
      line-height: 27px;
      margin-bottom: 50px;
    }
  }

  .cta-button {
    background-color: ${Colors.primary.claytonBlue.standard};
    border-color: transparent;
    border-radius: 2px;
    border-style: solid;
    border-width: 1px;
    color: white;
    cursor: pointer;
    flex-wrap: wrap;
    font-family: 'acumin-pro', sans-serif;
    justify-content: space-around;
    letter-spacing: 1px;
    padding: 17px 30px;
    width: 100%;
    display: inline-flex;
    margin-bottom: 18px;
    margin-top: 20px;
    margin: 20px auto 18px;
    text-decoration: none;
    transition: all 400ms ease-in-out;

    &:hover {
      background-color: ${Colors.primary.claytonBlue.hover};
    }
  }

  .quote-container {
    padding: 0 7% 0;
    margin-top: -50px;
    margin-bottom: 96px;

    .text-container {
      padding-top: 27px;
      width: 100%;
      margin: auto;
      max-width: 380px;
      display: block;

      h4 {
        font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
        line-height: 24px;
      }

      p {
        color: ${Colors.primary.claytonBlue.standard};
        font-weight: 600;
        font-size: 12px;
        line-height: 12px;
        margin-bottom: 16px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }

    picture {
      display: flex;

      img {
        width: 100%;
        margin: auto;
        max-height: 100%;
        display: block;
        width: auto;
        height: auto;
        max-width: 100%;

        @media screen and (min-width: ${tablet_portrait_breakpoint}px) {
          max-width: 380px;
          min-width: 320px;
        }
      }
    }
  }

  @media screen and (min-width: ${tablet_portrait_breakpoint}px) {
    .overview-container {
      padding: 55px 20% ${(props) => (props.quote ? '100px' : '55px')};
      text-align: center;
    }

    .cta-button {
      width: auto;
    }

    .quote-container {
      padding: 0 11% 0;

      .text-container {
        p {
          letter-spacing: 0.5px;
        }
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    .quote-container {
      display: flex;
      flex-direction: row;
      margin-top: -100px;
      padding: 0 20%;

      picture {
        margin-left: -40px;

        img {
          transform: scale(0.8);
          max-width: 320px;
        }
      }
    }
  }

  @media screen and (min-width: ${md_laptop_breakpoint}px) {
    .overview-container {
      padding: 55px 20% ${(props) => (props.quote ? '150px' : '55px')};
    }

    .quote-container {
      padding: 0 22%;

      picture {
        margin-left: 7%;

        img {
          transform: scale(1);
          max-width: 380px;
        }
      }

      .text-container {
        margin-left: 5%;
      }
    }
  }
`;

export default OverviewStyles;
